import { createApp } from 'vue'
// import 'vant/lib/index.css'
import { createHead } from '@unhead/vue/client'
import App from '@/App.vue'
import router from '@/router'
import pinia from '@/stores'
import VueScrollTo from 'vue-scrollto'
import 'virtual:uno.css'
import '@/styles/app.less'
import '@/styles/var.less'
import '@/styles/skin/config/skin.less'
import '@/styles/public.less'
import { i18n } from '@/utils/i18n'
import { Lazyload } from 'vant'

import { gameListApi, gameHallListApi } from '@/api/home'
import dragScroll from './directives/dragScroll'

// Vant 桌面端适配
import '@vant/touch-emulator'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'

const scrollOptions = {
  container: 'body', //滚动的容器
  duration: 500, //滚动时间
  easing: 'ease', //缓动类型
  offset: -50, // 滚动时应应用的偏移量。此选项接受回调函数
  force: true, // 是否应执行滚动
  cancelable: true, // 用户是否可以取消滚动
  onStart: false, // 滚动开始时的钩子函数
  onDone: false, // 滚动结束时候的钩子函数
  onCancel: false, // 用户取消滚动的钩子函数
  x: false, // 是否要在x轴上也滚动
  y: true, // 是否要在y轴上滚动
}

const app = createApp(App)
const head = createHead()

app.directive('drag-scroll', dragScroll)
app.use(VueScrollTo, scrollOptions)
// app.use(Lazyload)
app.use(Lazyload, {
  lazyComponent: true,
})
app.use(head)
app.use(router)
app.use(pinia)
app.use(i18n)

async function initializeApp() {
  const response = await fetch('/config.json')
  const localConfig = await response.json()
  const currentTheme = 'theme-skin' // 改成当前主题名称
  document.documentElement.setAttribute('data-theme', currentTheme)
  if (localConfig) {
    localStorage.setItem('localConfig', JSON.stringify(localConfig))
    try {
      // const baseUrl = import.meta.env.VITE_APP_API_BASE_URL
      // const response2 = await fetch(`${baseUrl}/initConfig`, {
      //   headers: {
      //     appid: btoa(localConfig.appid),
      //   },
      // })
      // if (!response2.ok) throw new Error(`HTTP error! status: ${response2.status}`)
      // const data = await response2.json()
      // localStorage.setItem('initConfig', JSON.stringify(data.data))
      // const brandsList = data.data.brands
      // const hotParams = { is_hot: 1, page: 1, limit: 8 }
      // await gameListApi(hotParams).then((res) => {
      //   const resList = res.data?.list
      //   if (resList?.length > 0) {
      //     resList[0]['count'] = res.data?.count
      //   }
      //   sessionStorage.setItem('hotList', JSON.stringify(resList))
      // })
      // const brandIdsString = brandsList
      //   .filter((item) => item && item.id !== undefined && item.id !== null)
      //   .map((item) => String(item.id))
      //   .join(',')
      // // 这里的入参limit: 16 可以跟进系列随机调整，目前先16  win1 16条  win2 8条  win3 8条
      // const typeParams = { brand_id: brandIdsString, limit: 8 }
      // await gameHallListApi(typeParams).then((res) => {
      //   const gameHomeModal = res.data?.games || {}
      //   // console.log('gameHomeModal:0', gameHomeModal) // count
      //   // count 未处理
      //   sessionStorage.setItem('gameHomeModal', JSON.stringify(gameHomeModal))
      // })
    } catch (error) {
      console.log('initConfig - error:', error)
    } finally {
      document.querySelector('.loadingbg').style.display = 'none'
      app.mount('#app')
    }
  } else {
    console.log('appid初始化出错')
  }
}

// 修改 router.isReady() 调用
router.isReady().then(() => {
  // 确保只调用一次初始化
  initializeApp()
})
